import { BaseApiService } from './BaseApiService';
import { I18nCatalogResponse, I18nLocalesResponse, SupportedLocale } from '../../i18n/types';

export interface I18nCatalogFetchResult {
  status: number;
  etag: string | null;
  data?: I18nCatalogResponse;
}

export class I18nService extends BaseApiService {
  async getLocalesMetadata(): Promise<I18nLocalesResponse> {
    return this.get<I18nLocalesResponse>('/i18n/locales');
  }

  async getCatalog(
    locale: SupportedLocale,
    namespaces: string[],
    etag?: string
  ): Promise<I18nCatalogFetchResult> {
    const url = new URL(`${BaseApiService.BASE_URL}/i18n/catalog/${locale}`);
    if (namespaces.length > 0) {
      url.searchParams.set('namespaces', namespaces.join(','));
    }

    const headers = new Headers();
    if (etag) {
      headers.set('If-None-Match', etag);
    }

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers,
    });

    if (response.status === 304) {
      return {
        status: 304,
        etag: response.headers.get('ETag'),
      };
    }

    if (!response.ok) {
      throw new Error(`Failed to fetch catalog: ${response.status} ${response.statusText}`);
    }

    const payload = (await response.json()) as I18nCatalogResponse;

    return {
      status: response.status,
      etag: response.headers.get('ETag'),
      data: payload,
    };
  }
}
